module.exports = __webpack_public_path__ + "img/player-play-icon.c112f612.svg";